import { ICON__trash_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_10_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_10_5';
import { INVOCATION__base } from '@shared/dto/generation/graph_invoke/_invocations/_base/INVOCATION__base';
import { useReactFlow } from '@xyflow/react';

interface PROPS {
  invocation: INVOCATION__base;
}

export function G_BUTTON__node_remove({ invocation }: PROPS) {
  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { deleteElements } = useReactFlow();
  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();

    deleteElements({ nodes: [{ id: invocation.meta.node_id }] });
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  if (!invocation.meta.is_deletable) return <PLACEHOLDER_BUTTON__bar_10_5 />;

  return (
    <UI_PRIMITIVE__button size="square-5" variant={'no-border-on-component'} disabled={is_disabled()} {...{ onClick }}>
      <ICON__trash_solid className="w-4 h-4" />
    </UI_PRIMITIVE__button>
  );
}
